"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customersById = void 0;
exports.customersById = (state = {}, action = {}) => {
    switch (action.type) {
        case 'CUSTOMER_GET_BY_ID_RECEIVE':
        case 'CUSTOMER_UPDATE_RECEIVE':
        case 'CUSTOMER_CREATE_RECEIVE':
        case 'CUSTOMER_VALIDATE_RECEIVE':
            return Object.assign(Object.assign({}, state), { [action.payload.id]: action.payload.customer });
        case 'CUSTOMER_ACCOUNT_CREATE_RECEIVE':
            // Only allowed one account per "source"
            const customer = state[action.payload.id] || {};
            const accounts = [...(customer.accounts || [])];
            const existingIndex = accounts.findIndex((a) => a.source === action.payload.account.source);
            if (existingIndex >= 0) {
                accounts.splice(existingIndex, 1, action.payload.account);
            }
            else {
                accounts.push(action.payload.account);
            }
            return Object.assign(Object.assign({}, state), { [action.payload.id]: Object.assign(Object.assign({}, customer), { accounts }) });
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map